import { takeLatest, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import {
  GET_UTILITY_USER_DETAILS,
  GET_UTILITY_USER_DETAILS_SUCCESS,
  GET_UTILITY_USER_DETAILS_ERROR,
} from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getUtilityUserDetails({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders, 'project-code': 'ADMIN_ACCESS' };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/utility-request/user-details`,
      method: 'GET',
      headers: filteredHeaders,
      params: { email: payload.email },
    });

    const isError = response?.data?.status === 'error' || !response?.data?.data;

    if (response.status === 200 && !isError) {
      yield put({ type: GET_UTILITY_USER_DETAILS_SUCCESS, payload: response?.data });
    } else {
      yield put({
        type: GET_UTILITY_USER_DETAILS_ERROR,
        payload: response?.data?.message || 'User not found',
      });
    }
  } catch (error) {
    yield put({ type: GET_UTILITY_USER_DETAILS_ERROR, payload: 'User not found' });
  }
}

export function* watchGetUtilityUserDetails() {
  yield takeLatest(GET_UTILITY_USER_DETAILS, getUtilityUserDetails);
}

function* getUtilityUserDetailsSaga() {
  yield all([fork(watchGetUtilityUserDetails)]);
}

export default getUtilityUserDetailsSaga;
